<template>
  <div class="v-menu-btn">
    <!-- {{ menuModel }} -->
    <!-- hasSearch: {{ hasSearch }} -->
    <!-- keepOpen:{{ keepOpen }} -->
    <!-- {{ filteredList }} -->

    <v-menu
      v-model="menuModel"
      :close-on-click="!modal"
      :key="menuKey"
      :close-on-content-click="!keepOpen && !selectable && !hasSearch"
      top
    >
      <template v-slot:activator="{ on, attrs }">
        <component
          :is="textBelow ? 'div' : 'v-btn'"
          :small="small"
          :x-small="xsmall"
          :text="text"
          :color="color"
          :dark="dark"
          :rounded="rounded"
          :outlined="outlined"
          v-bind="attrs"
          v-on="on"
          :fab="fab"
        >
          <v-icon
       
            :color="color"
            :class="textBelow ? '' : 'ma-2'"
            >{{ icon }}</v-icon
          >
          <div v-if="textBelow" class="btn-text">{{ title }}</div>
          <span class="v-btn" v-else
            ><span
              class="v-btn"
              v-if="!$root.isMobile && !$root.isTablet"
              >{{ title }}</span
            ></span
          >
        </component>
      </template>
      <v-toolbar v-if="hasSearch || modal" flat>
        <v-text-field
          v-model="search"
          v-if="hasSearch"
          prepend-inner-icon="mdi-magnify"
          single-line
          class="pa-2"
          hide-details
          clearable
          :label="searchLabel"
        ></v-text-field>

        <!-- <v-spacer></v-spacer> -->
        <!-- <v-btn v-if="reset && itemSelected" icon color="warning" class="ma-1">
          <v-icon
            @click="
              itemSelected = false;
              reset();
            "
            >mdi-cancel</v-icon
          >
        </v-btn> -->
        <v-btn v-if="apply && itemSelected" class="ma-1" icon>
          <v-icon
            color="success"
            @click="
              itemSelected = false;
              apply(true);
            "
            >mdi-checkbox-marked-circle</v-icon
          >
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="collapsible" @click="listOpen = !listOpen" icon>
          <v-icon v-if="listOpen">mdi-arrow-collapse-up</v-icon>
          <v-icon v-else>mdi-arrow-expand-down</v-icon>
        </v-btn>
        <v-btn @click="menuModel = false" v-if="modal" icon>
          <v-icon>mdi-close-circle</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card v-if="listOpen" flat>
        <v-card-title v-if="filteredItem.name">
          {{ capitalize(filteredItem.name) }}
        </v-card-title>

        <v-row class="filtered-buttons  ">
          <v-col v-if="myFilterButtons">
            <v-list
              :class="
                $vuetify.breakpoint.smAndDown
                  ? 'd-flex flex-wrap justify-start'
                  : ''
              "
              style="row-gap: 16px; column-gap: 16px; flex-list"
              dense
            >
              <v-list-item>
                <v-btn
                  v-if="filteredItem.name"
                  class="ma-2"
                  @click="
                    filteredItem = {};
                    searchLabel = 'Search All';
                  "
                  text
                  small
                  color="error"
                >
                  <v-icon small class="ma-2" large>mdi-filter-remove</v-icon
                  ><span v-if="$vuetify.breakpoint.mdAndUp">Show All</span>
                </v-btn>
              </v-list-item>

              <v-list-item
                v-for="b in myFilterButtons"
                style="flex: 1 1 calc(25% - 16px);"
                :key="b.name"
              >
                <v-btn
                  class="ma-2"
                  @click="filterList(b)"
                  :color="filteredItem.name === b.name ? 'success' : ''"
                  text
                  small
                >
                  <v-icon class="ma-2" large>{{ b.icon }}</v-icon
                  ><span v-if="$vuetify.breakpoint.mdAndUp">{{
                    capitalize(b.name)
                  }}</span>
                </v-btn>
              </v-list-item>
            </v-list></v-col
          >
          <v-col
            ><v-list
              ref="list"
              :key="listKey"
              v-if="!userEntry && !displayTable"
              class="front menu-btn-list"
            >
              <v-row class="ma-2" v-if="selectable">
                <v-col>
                  <v-switch
                    v-model="selected"
                    @change="selectAll()"
                    :label="
                      selected
                        ? selectAllCaption[1] + ' All'
                        : selectAllCaption[0] + ' All'
                    "
                  ></v-switch>
                </v-col>
              </v-row>
              <hr v-if="selectable" />

              <v-list-item v-for="(item, index) in filteredList" :key="index">
                <v-switch
                  v-model="item[selectProperty]"
                  @change="changeSelect(item)"
                  v-if="selectable"
                ></v-switch>

                <v-list-item color="info">
                  <v-list-item-content>
                    <v-list-item-title
                      @click="
                        itemSelected = true;
                        sendValue(item);
                      "
                      v-text="item.text"
                    ></v-list-item-title>
                  </v-list-item-content>

                  <!-- <v-list-item-action >
              <v-btn text @click="sendValue(item)">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn></v-list-item-action
            >

            <v-list-item-action v-if="canEditNew">
              <v-btn text @click="sendValue(item, true)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn></v-list-item-action 
            >-->
                </v-list-item>
              </v-list-item>
            </v-list>

            <div class="table-container">
              <!-- <v-pagination
                v-model="page"
                :length="totalPages"
                total-visible="7"
                class="my-4"
              ></v-pagination> -->
              <!-- filteredList:{{ filteredList }} -->
              <!-- editableFields:{{ editableFields }} -->
              <!-- displayTable:{{ displayTable }} userEntry: {{ userEntry }} -->
              <v-data-table
                dense
                v-if="userEntry || displayTable"
                :headers="headers"
                :items="filteredList"
                :items-per-page="itemsPerPage"
                class="elevation-1"
                :footer-props="footerProps"
                :disable-pagination="filteredList <= itemsPerPage"
                hide-default-header
                :hide-default-footer="false"
              >
                <template v-slot:item.value="{ item }">
                  <!-- {{ item }} -->

                  <v-row class="d-flex align-start mt-2">
                    <v-col class="d-flex align-start">
                      <span v-if="editableFields && editableFields.length">
                        <!-- <v-edit-dialog
                          v-for="(c, i) in editableFields"
                          :key="i"
                          v-model="dialogModel"
                        >
                          <div class="underscore-button ma-2">
                            {{ item[c.name] }}
                          </div> -->

                        <!-- <template v-slot:input> -->
                        <!-- editableFields:{{ editableFields }} -->
                        <v-text-field
                          v-for="(c, i) in editableFields"
                          :key="i"
                          dense
                          class="ma-4"
                          style="width: 50px"
                          type="number"
                          v-model="item[c.name]"
                        ></v-text-field>
                        <!-- </template>
                        </v-edit-dialog> -->
                      </span>
                      <!-- <v-col class="d-flex align-start"> -->

                      <v-btn
                        class="d-flex align-start mt-6"
                        text
                        @click="sendValue(item)"
                      >
                        {{ item.text }}
                      </v-btn></v-col
                    >
                    <!-- </v-col> -->
                  </v-row>
                </template>

                <template v-slot:item.actions="{ item }">
                  <v-toolbar flat>
                    <!-- <v-col>  -->
                    <v-spacer></v-spacer>
                    <v-btn icon>
                      <v-icon @click="sendValue(item)"
                        >mdi-arrow-right</v-icon
                      ></v-btn
                    >

                    <!-- </v-col>
              <v-col
                > -->
                    <v-btn v-if="canEditNew" icon>
                      <v-icon @click="sendValue(item, true)"
                        >mdi-pencil</v-icon
                      ></v-btn
                    >

                    <!-- </v-col
              > -->
                  </v-toolbar>
                </template>
                <!-- <template v-slot:footer>
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                    total-visible="7"
                    class="my-4"
                  ></v-pagination>
                </template> -->
              </v-data-table>
            </div>
            <!-- userEntry {{ userEntry }} toolbarReady:{{ toolbarReady }} -->
            <v-toolbar
              class="pl-2 pr-4 pt-4"
              :key="customToolBarKey"
              flat
              v-if="userEntry && toolbarReady"
            >
              <v-row>
                <v-col cols="2" v-if="editableFields && editableFields.length">
                  <!-- <v-edit-dialog v-model="dialogModel"> -->
                  <!-- <div class="underscore-button mt-2">
                      {{ custom.qty || 1 }}
                    </div> -->
                  <!-- <v-btn>
              </v-btn> -->
                  <!-- <template v-slot:input> -->
                  <v-text-field
                    dense
                    class="ma-2"
                    style="width: 50px"
                    type="number"
                    v-model="custom.qty"
                  ></v-text-field>
                  <!-- </template> </v-edit-dialog
                > -->
                </v-col>
                <v-col>
                  <v-text-field
                    v-if="
                      !customItemTemplate ||
                        !filteredCustomItemTemplate ||
                        !filteredCustomItemTemplate.length
                    "
                    v-model="custom.value"
                    class="ma-2"
                    clearable
                    label="Custom Item"
                  ></v-text-field></v-col
              ></v-row>

              <!-- <div v-else> -->
              <!-- {{ customItemTemplate }} -->
              <!-- {{ filteredCustomItemTemplate }} -->

              <h5
                class="ml-n8"
                v-if="
                  filteredCustomItemTemplate &&
                    filteredCustomItemTemplate.length
                "
              >
                Custom
              </h5>
              <component
                v-for="(c, i) in filteredCustomItemTemplate"
                :key="i"
                :is="c.comp"
                :ref="c.id"
                :id="c.id"
                v-model="custom[c.id]"
                v-bind="c[`v-bind`]"
              >
              </component>
              <!-- </div> -->

              <v-btn @click="sendValue(custom, false, true)" icon>
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-toolbar></v-col
          >
        </v-row></v-card
      >
    </v-menu>
  </div>
</template>
<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  props: {
    schema: Object,
    data_key: String,
    VModel: Object,
    itemModel: [Object, Array, String],
    color: String,
    k: String,
    model_key: String,
    formModel: [Object, Array, String],
    capitalizeText: Boolean,
    title: String,
    objectName: String,
    objName: String,
    itemText: String,
    itemValue: String,
    menuItems: Array,
    sideModel: Object,
    id: String,
    icon: String,
    small: Boolean,
    xsmall: Boolean,
    text: Boolean,
    dark: Boolean,
    rounded: Boolean,
    flat: Boolean,
    outlined: Boolean,
    menuItemClick: Function,
    sort: String,
    filter: String,
    fab: Boolean,
    textBelow: Boolean,
    selectable: Boolean,
    selectAllCaption: Array,
    hasSearch: Boolean,
    selectProperty: String,
    changeSelect: Function,
    allFields: Boolean,
    userEntry: Boolean,
    customItemTemplate: Array,
    customTemplate: String,
    modal: Boolean,
    apply: Function,
    reset: Function,
    getItems: Boolean,
    table: Object,
    editableFields: Array,
    defaultData: Object,
    customTemplateCondition: String,
    collapsible: Boolean,
    canEditNew: Boolean,
    displayTable: Boolean,
    prepareRecords: String,
    keepOpen: Boolean,
    filterButtons: Array,
    filterButtonsObject: Object,
    filterProp: String,
    defaultFilter: String,
    closeMenuOnClick: Boolean,
  },
  components: {
    VFormComponent: () => import("./FormComponent.vue"),
  },
  data() {
    return {
      options: [],
      search: "",
      item: "",
      itemsPerPage: 50,
      model: "",
      menuModel: 0,
      selected: 0,
      custom: { text: "" },
      itemSelected: false,
      listOpen: true,
      listKey: 0,
      currentObjectName: "",
      // filteredCustomItemTemplate: [],
      customToolBarKey: 0,
      toolbarReady: true,
      headers: [
        { text: "Item", value: "value" },
        { text: "", value: "actions", sortable: false },
      ],
      filteredItem: {},
      page: 1,
      searchLabel: "Search All",
      myFilterButtons: [],
    };
  },
  methods: {
    closeMenu() {
      if (this.closeMenuOnClick) {
        this.menuModel = 0;
      }
    },
    filterList(item) {
      // this.currentObjectName = this.objectName || this.objName;
      this.filteredItem = item;

      this.searchLabel = "Search in " + fun.capitalize(this.filteredItem.name);

      if (item.objName && item.objName != this.currentObjectName) {
        this.currentObjectName = item.objName;
        this.populateItems(item);
        //
      } else if (
        !item.objName &&
        this.currentObjectName != this.objectName &&
        this.currentObjectName != this.objName
      ) {
        this.currentObjectName = this.objectName || this.objName;
        this.populateItems();
      }
      // console.log(item);
      // this.filteredList.filter((l) => {
      //   return l.rec[this.filterProp] == item;
      // });
    },
    // handleOutsideClick(e) {
    //   if (
    //     this.menuModel &&
    //     !this.$refs.specificDiv.contains(e.target) &&
    //     !this.$el.contains(e.target)
    //   ) {
    //     this.menuModel = false;
    //   }
    // },
    stayOpen() {
      this.menuModel = 1;
    },
    selectAll() {
      var that = this;
      this.options.forEach((r, i) => {
        r[this.selectProperty] = this.selected;

        that.changeSelect(r, i < this.options.length - 1);
      });
      // this.options.forEach((r) => {
      //   this.changeSelect(r);
      // });
    },
    checkTemplateConditions() {
      if (this.customTemplateCondition) {
        const options = this.options;
        var conditionMet = false;
        try {
          conditionMet = eval(this.customTemplateCondition);
        } catch (error) {
          //
        }

        //
        if (conditionMet) {
          this.custom = {};
        }
        // } else {
        //   this.filteredCustomItemTemplate = this.customItemTemplate;
      }
      this.toolbarReady = true;
    },
    capitalize(item) {
      return fun.capitalize(item);
    },
    sendValue(item, edit, isCustom) {
      // if (this.table) {
      //   // this.table.page = parseInt(this.table.itemsLength / this.table.itemsPerPage);
      //   this.table.navigate("last");
      // }
      if (isCustom && !item.rec) {
        item.rec = {};
        if (this.defaultData) {
          item.rec = this.defaultData;
        }
      }

      Object.keys(item).forEach((k) => {
        if (k != "rec" && k != "text" && k != "value" && item.rec) {
          item.rec[k] = item[k];
        }
      });
      if (this.itemSelected && this.apply && !isCustom) {
        this.apply(item);
      }
      if (
        this.customTemplate &&
        fun.isObjectAndNotEmpty(this.custom) &&
        isCustom &&
        !item.value
      ) {
        try {
          item = eval(this.customTemplate);
        } catch (error) {
          //
        }
      }

      var data = {
        id: this.id,
        item: item,
        filteredItem: this.filteredItem,
        formModel: this.formModel,
        objectName: this.objectName || this.objName,
        objName: this.objectName || this.objName,
        first_option: this.options[0],
      };
      // if (this.id) {

      if (!this.menuItemClick) {
        const parent = fun.getParentByProperty(this, "shipmentId");
        data.parent = parent;
        this.$root.$emit("customBtnClick", data);
      } else {
        this.menuItemClick(data, edit);
      }
      item = {
        ...item,
        ...this.defaultData,
      };
      this.itemSelected = edit;
      if (this.closeMenuOnClick) {
        this.menuModel = false;
      }

      // }
    },
    collapseMenu() {
      var el = this.$refs.list;
    },
    populateItems(i) {
      var that = this;
      this.options = [];
      // var objectName = this.objectName || this.objName;
      const url =
        this.serverURL +
        "/get_records_qry_string?object_name=" +
        this.currentObjectName;
      axios
        .get(url, {
          withCredentials: true,
        })
        .then((res) => res.data)
        .then((res) => {
          var records = res.results[0];
          if (that.prepareRecords) {
            var par = fun.findParent(that, that.prepareRecords);
            if (par) {
              records = par[that.prepareRecords](records);
            }
          }
          if (that.filter) {
            records = records.filter((r) => {
              return eval(that.filter);
            });
          }
          if (this.sort) {
            records.sort((a, b) => {
              return fun.compare(a, b, this.sort);
            });
          }
          records.forEach((r) => {
            if (i && i.property) {
              r[i.property] = i.name;
            }
            var d = {
              text: this.capitalizeText
                ? fun.capitalize(r[i ? i.itemText : this.itemText])
                : r[this.itemText],
              value: r[i ? i.itemValue : this.itemValue],

              rec: r,
            };
            if (this.defaultData) {
              d = {
                ...d,
                ...this.defaultData,
              };
            }

            that.options.push(d);
            // this.checkTemplateConditions();
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  mounted() {
    var that = this;
    this.myFilterButtons = this.filterButtons;
    if (this.filterButtonsObject) {
      const url =
        this.serverURL +
        "/get_records_qry_string?object_name=" +
        this.filterButtonsObject.objName;
      axios
        .get(url, {
          withCredentials: true,
        })
        .then((res) => res.data)
        .then((res) => {
          var records = res.results[0];
          this.myFilterButtons = [];
          records.forEach((b) => {
            this.myFilterButtons.push({
              name: b[this.filterButtonsObject.itemText],
              icon: "mdi-" + b[this.filterButtonsObject.itemIcon],
            });
          });
        });
    }
    if (this.defaultFilter) {
      this.filteredItem.name = this.defaultFilter;
      this.searchLabel = "Search in " + fun.capitalize(this.filteredItem.name);
    }
    // filteredCustomItemTemplate() {

    // },
    // if (this.tableTop) {
    //   console.log("table top", this.tableTop);
    // }
    // console.log(this.getItems);
    // this.$root.$on("keepMenu", (e) => {
    //   if (e == that.data_key) {
    //     that.menuModel = 0;
    //     that.stayOpen();
    //   }
    // });
    // document.addEventListener("click", this.handleOutsideClick);

    if (this.getItems) {
      this.$root.$on("get_menu_items", function(r) {
        // if (that._uid != that.$root.shipmentUid) {
        //   return;
        // }

        that.options = r.items;
        // that.checkTemplateConditions();

        // that.listKey = !that.listKey;
        // that.customToolBarKey = !that.customToolBarKey;
      });
      if (!this.menuItems || !this.menuItems.length) {
        return;
      }
    }

    if (this.menuItems && this.menuItems.length) {
      var items = this.menuItems;
      if (this.capitalizeText) {
        that.options = items;
      } else {
        items.forEach(function(i) {
          that.options.push({
            text: i.itemText || fun.capitalize(i),
            value: i.itemValue || i,
          });
        });
      }
    }
    if (this.options) {
      this.selected = !this.options.some((r) => {
        return !r[this.selectProperty];
      });
    }
    if ((this.objectName || this.objName) && !this.getItems) {
      this.currentObjectName = this.objectName || this.objName;
      this.populateItems();
    }
  },
  watch: {
    options: {
      handler: function(newValue, oldValue) {
        // console.log(newValue);
      },
      deep: true,
    },
    // menuOpen: {
    //   handler: function(newValue, oldValue) {
    //     this.menuModel = newValue;
    //   },
    // },
  },
  computed: {
    footerProps() {
      if (this.filteredList.length <= 100) {
        // Hide pagination controls if 100 items or fewer
        return {
          "items-per-page-options": [],
          "show-current-page": false,
          "show-first-last-page": false,
        };
      } else {
        // Show standard pagination controls
        return {
          "items-per-page-options": [10, 20, 100, -1],
          "show-current-page": true,
          "show-first-last-page": true,
        };
      }
    },
    totalPages() {
      return Math.ceil(this.filteredList.length / this.itemsPerPage);
    },
    filteredCustomItemTemplate() {
      const options = this.options;
      try {
        if (eval(this.customTemplateCondition)) {
          return this.customItemTemplate;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    filteredList() {
      var that = this;
      if (!this.options) {
        return [];
      }

      fun.sortObjects(this.options, "text");
      return that.options.filter((item) => {
        return item.text && that.filteredItem.name && that.filterProp
          ? item.rec &&
              item.rec[that.filterProp] == that.filteredItem.name &&
              (!that.search ||
                item.text.toLowerCase().includes(that.search.toLowerCase()))
          : item.text &&
              (!that.search ||
                item.text.toLowerCase().includes(that.search.toLowerCase()));
      });
    },
  },
};
</script>
<style>
.table-container {
  max-height: 50vh;
  overflow-y: auto;
}
.btn-text {
  text-transform: toUpperCase;
}
.underscore-button {
  text-decoration: underline;
  color: blue;
  font-size: small;
  /* border: solid 1px; */
  /* border-radius: 10px; */
  /* padding: 5px; */
}
.small {
  font-size: small;
}
.filtered-buttons {
  z-index: 1020 !important;
  background-color: white;
}
.v-menu-btn {
  /* width: 80%; */
}
.v-menu-btn .select {
  z-index: 1020 !important;
  background-color: white;
}
.v-menu-btn .v-menu__content {
  background-color: white !important;
}
.menu-btn-list {
  max-height: 200px;
  overflow-y: auto;
}
.selected-item {
  background-color: yellow;
}

@media only screen and (max-width: 450px) {
  .v-list {
    display: flex; /* Ensures flexbox layout */
    flex-wrap: wrap; /* Enables wrapping to next row */
    row-gap: 16px; /* Spacing between rows */
    column-gap: 16px; /* Spacing between columns */
  }
  .v-menu-btn {
    /* width: 100vh; */
  }
}
</style>
